import React from 'react';
import { MobileDataControl } from '../MobileDataControl';
import { Calendar } from 'antd';

import { DENSITY_MONTH_CONSTANT } from '../../constant/DENSITY_MONTH_CONSTANT';
import moment from 'moment';

import './MobileDataDaily.scss';

moment.updateLocale('en', {
  weekdaysMin: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
});

/**
 * @param {object} props
 * @param {(value: { year: number, month: number, day: number }) => void} props.onChange
 * @param {{ year: number, month: number, day: number }} props.value
 * @param {number[]} props.providedYear
 */
export const MobileDataDaily = (props) => {
  const {
    onChange,
    providedYear,
    value,
  } = props;
  const now = moment().subtract(8, 'days');
  const month = DENSITY_MONTH_CONSTANT.find((v) => v.value === value.month)?.label;
  const maxMonth = value.month === 12;
  const minMonth = value.month === 1;

  const renderHeader = (cb) => {
    return (
      <MobileDataControl
        disabledNext={
          !providedYear.includes(value.year + 1) && value.month >= (now.month() + 1)
        }
        disabledPrev={!providedYear.includes(value.year - 1) && value.month === 1}
        onNext={() => {
          const year = maxMonth ? value.year + 1 : value.year;
          const month = maxMonth ? 1 : value.month + 1;
          const now = cb.value.clone();
          now.month(month - 1);
          now.year(year);
          now.auto = true;
          cb.onChange(now);
        }}
        onPrev={() => {
          const year = minMonth ? value.year - 1 : value.year;
          const month = minMonth ? 12 : value.month - 1;
          const now = cb.value.clone();
          now.month(month - 1);
          now.year(year);
          now.auto = true;
          cb.onChange(now);
        }}
      >
        <div className='month-year'>
          {month} {value.year}
        </div>
      </MobileDataControl>
    );
  };

  return (
    <div className='feature-genset-MD MobileDataDaily'>
      <div className='MobileDataDaily-info'>
        You can only use data from 8 days prior to the current date
      </div>
      <Calendar
        className='MobileDataDaily-date'
        disabledDate={(cd) => cd.isAfter(now)}
        fullscreen={false}
        headerRender={renderHeader}
        onChange={(val) => {
          if (!val.isAfter(now)) {
            onChange({
              year: parseInt(val.format('YYYY')),
              month: parseInt(val.format('MM')),
              day: parseInt(val.format('DD')),
              auto: val.auto,
            });
          } else {
            if (val.month() === now.month()) {
              onChange({
                year: parseInt(val.format('YYYY')),
                month: parseInt(val.format('MM')),
                day: now.get('D'),
                auto: val.auto,
              });
            }
          }
        }
        }
        value={moment(
          `${value.year}-${value.month}-${value.day}`,
          'YYYY-MM-DD'
        )}
      />
    </div>
  );
};
